<script lang="ts">
	// Size constraints
	export let width: number = 130;
	export let height: number = 80;
	export let className: string = "";

	// Font Awesome overlays (solid)
	export let topIconClass: string = "fa-solid fa-location-dot";    // Alaska
	export let bottomIconClass: string = "fa-solid fa-location-dot"; // Argentina

	// Texts
	export let distanceText: string = "~30,000 km"; // optional override
</script>

<div class="relative" style={`width:${width}px;height:${height}px;`}>
	<svg
		{width}
		{height}
		viewBox="0 0 130 80"
		xmlns="http://www.w3.org/2000/svg"
		role="img"
		aria-label="Pan-American Highway passport stamp"
		class={className}
	>
		<title>Pan-American Highway Passport Stamp</title>

		<defs>
			<!-- Crest badge outline path -->
			<!-- Top scalloped arch, straight sides, bottom wedge -->
			<path id="crestOutline" d="
				M 20 18
				C 32 10, 50 8, 65 8
				C 80 8, 98 10, 110 18
				L 110 52
				L 84 68
				L 65 74
				L 46 68
				L 20 52
				Z
			" />

			<!-- Inset crest (offset inward ~4px via simplified coordinates) -->
			<path id="crestInset" d="
				M 24 20
				C 35 13, 51 11, 65 11
				C 79 11, 95 13, 106 20
				L 106 50
				L 82 65
				L 65 70
				L 48 65
				L 24 50
				Z
			" />

			<!-- Top arch path for title text -->
			<path id="titleArch" d="M 20 15 Q 65 -2 110 15" />
			<path id="subtitleArch" d="M 28 25 Q 65 10 102 25" />

			<!-- Faint ink bleed behind the title -->
			<path id="inkArch" d="M 24 20 Q 65 4 106 20" />
		</defs>

		<!-- Unique creative border: crest outline -->
		<use href="#crestOutline" fill="none" stroke="#000" stroke-width="2" />

		<!-- Micro rivet accents on vertical sides -->
		<g fill="#000" opacity="0.85">
			<!-- Left side rivets -->
			<circle cx="23" cy="34" r="1.2" />
			<circle cx="23" cy="44" r="1.2" />
			<!-- Right side rivets -->
			<circle cx="107" cy="34" r="1.2" />
			<circle cx="107" cy="44" r="1.2" />
		</g>

		<!-- Inner dashed crest inset -->
		<use href="#crestInset" fill="none" stroke="#000" stroke-width="1" stroke-dasharray="3 2" opacity="0.9" />

		<!-- Guilloche bead dash inside inset -->
		<use href="#crestInset" fill="none" stroke="#000" stroke-width="1" stroke-linecap="round" stroke-dasharray="0.35 4" opacity="0.85" />

		<!-- Faint ink bleed behind title -->
		<use href="#inkArch" fill="none" stroke="#000" stroke-width="6" opacity="0.08" stroke-linecap="round" />

		<!-- Title on arch -->
		<text fill="#000" font-size="9" font-weight="900" letter-spacing="1.6" text-anchor="middle" style="paint-order: stroke fill; stroke:#000; stroke-width:0.5;">
			<textPath href="#titleArch" startOffset="50%">PAN-AMERICAN</textPath>
			<textPath href="#subtitleArch" startOffset="50%">HIGHWAY</textPath>
		</text>

		<!-- Vertical spine route (slightly meandering) -->
		<path d="M 65 28 Q 60 38 65 44 Q 70 56 65 62" fill="none" stroke="#000" stroke-width="1.2" opacity="0.35" stroke-linecap="round" />

		<!-- Small tick marks along the spine -->
		<!-- <g stroke="#000" stroke-width="1" opacity="0.85" stroke-linecap="round">
			<path d="M 62 28 L 68 28" />
			<path d="M 61.5 36 L 68.5 36" />
			<path d="M 62 44 L 68 44" />
			<path d="M 61.5 52 L 68.5 52" />
			<path d="M 62 60 L 68 60" />
		</g> -->

		<!-- Distance and secondary text centered near lower panel -->
		<g transform="translate(65,60)">
			<text x="0" y="-18" fill="#000" font-size="8.5" font-weight="800" text-anchor="middle" style="letter-spacing:0.8px;">{distanceText}</text>
			<text x="0" y="-10" fill="#000" font-size="6.4" font-weight="600" text-anchor="middle" opacity="0.65" style="letter-spacing:0.5px;">ALASKA • ARGENTINA</text>
		</g>

		<!-- Small compass/star accent -->
		<!-- <g transform="translate(28,34) scale(0.9)" opacity="0.15" fill="#000">
			<path d="M 0 -4 L 1.2 -1.2 L 4 0 L 1.2 1.2 L 0 4 L -1.2 1.2 L -4 0 L -1.2 -1.2 Z" />
		</g> -->
	</svg>

	<!-- Font Awesome overlays: endpoints and route icon (black-only) -->
	<!-- Alaska (top) -->
	<div class="absolute" style="top: 28px; left: 65px; transform: translate(-50%, -50%); color:#000;">
		<i class={topIconClass} style="font-size:14px; line-height:1; color:#000; opacity:0.95;"></i>
	</div>

	<!-- Route icon mid-spine -->
	<!-- <div class="absolute" style="top: 40px; left: 65px; transform: translate(-50%, -50%) rotate(-8deg); color:#000;">
		<i class={routeIconClass} style="font-size:16px; line-height:1; color:#000; opacity:0.95;"></i>
	</div> -->

	<!-- Argentina (bottom) -->
	<div class="absolute" style="top: 66px; left: 65px; transform: translate(-50%, -50%); color:#000;">
		<i class={bottomIconClass} style="font-size:14px; line-height:1; color:#000; opacity:0.95;"></i>
	</div>
</div>
